import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Injectable, OnChanges, Renderer2, RendererFactory2, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as mapboxgl from 'mapbox-gl';
import { DashboardpenelComponent } from 'src/app/dashboard/dashboardpenel/dashboardpenel.component';
import { environment } from '../../../environments/environment';
import { areas, areaBounds, areaCentroids } from "../geojson/index";
import { UserService } from './user.service';
import { DynamicComponentService } from "./dynamic-component.service";
import { Router } from '@angular/router';
import { IWGSharedService } from '../../shared/services/shared.service';
import Point from 'ol/geom/Point';

@Injectable({
    providedIn: 'root'
})

export class MapService implements OnChanges {
    map: mapboxgl.Map;
    style = 'mapbox://styles/eedelstein/cixqym350000b2rn847shrpr5';
    lat = 45.899977;
    lng = 6.172652;
    zoom = 1;
    maploaded: boolean = false;
    private renderer: Renderer2

    constructor(rendererFactory: RendererFactory2, private number: DecimalPipe, private currency: CurrencyPipe,
        private user: UserService,
        private dialog: MatDialog,
        private dynamicComponentService: DynamicComponentService,
        private router: Router, private sharedService: IWGSharedService,
    ) {
        (mapboxgl as any).accessToken = environment.mapbox.accessToken;
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    ngOnChanges(changes: SimpleChanges) {       
    }

    buildMap = () => {

        this.map = new mapboxgl.Map({
            accessToken: environment.mapbox.accessToken,
            container: 'map',
            style: this.style,
            zoom: this.zoom,
            center: [this.lng, this.lat]
        })
        this.dropBounds();
        this.map.addControl(new mapboxgl.NavigationControl({showCompass:false}), 'bottom-right');
        this.map.on("load", (data) => {            
            const pointer = this.renderer.createElement('span');
            this.renderer.addClass(pointer, "iwg-dashboard-panel-pointer");
            const marker = this.renderer.createElement('span');
            this.renderer.appendChild(pointer, marker);           
            this.map.getContainer().appendChild(pointer);
            this.map.addSource("areas", {
                type: "geojson",
                data: areas
            });
            this.map.addSource('country-centroids', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: []
                }
            });
            this.map.addLayer({
                id: 'areas-borders',
                type: 'line',
                source: 'areas',
                layout: {
                    'line-join': 'round',
                    'line-cap': 'round'
                },
                paint: {
                    'line-color': '#333333',
                    'line-width': 2
                },
                filter: ['!has', 'code']
            });

            this.map.addLayer({
                id: 'areas',
                type: 'fill',
                source: 'areas',
                paint: {
                    'fill-color': '#33a3be',
                    'fill-opacity': .7
                },
                filter: ['!has', 'code']
            });


            this.map.addLayer({
                id: 'marker-outer-circles',
                type: 'circle',
                source: 'country-centroids',
                paint: {
                    'circle-color': '#ffffff',
                    'circle-opacity': .5,
                    'circle-radius': 20
                }
            });

            this.map.addLayer({
                id: 'marker-circles',
                type: 'circle',
                source: 'country-centroids',
                paint: {
                    'circle-color': '#224d95',
                    'circle-radius': 14
                }
            });

            this.map.addLayer({
                id: 'marker-labels',
                type: 'symbol',
                source: 'country-centroids',
                layout: {
                    'text-size': 13,
                    'icon-allow-overlap': true,
                    'text-field': '{workerCountMarkerLabel}'
                },
                paint: {
                    'text-color': '#ffffff'
                }
            });
            this.maploaded = true;
            let prevFeature: any;
            let pop = null;
            let popup = new mapboxgl.Popup({
                offset:0,
                closeButton: false,
                closeOnClick: false
            });


            // this.map.on('mouseenter', 'marker-circles', (e) => {
            //     let features = this.map.queryRenderedFeatures(e.point, {
            //         layers: ['marker-labels', 'marker-circles']
            //     });
            //     console.log("LAYER", this.map.getStyle().layers);
            //     // Change the cursor style as a UI indicator.
            //     this.map.getCanvas().style.cursor = (features.length) ? 'pointer' : '';

            //     if (!features.length) {
            //         // Reset filter
            //         prevFeature = { properties: {} };
            //         this.map.setFilter('areas-borders', ['!has', 'code']);
            //         return;
            //     }

            //     let feature = features[0];
            //     this.map.setFilter('areas-borders', ['==', 'code', feature.properties.code]);

            //     // Add popover
            //     let points: Point = <Point>feature.geometry;
            //     let c = points.coordinates;
            //     let point = this.map.project(c);
            //     let containerBounds = this.map.getContainer().getBoundingClientRect();

            //     marker.innerHTML = feature.properties.workerCountMarkerLabel;
                

            //     //Object.assign(panelRef.config.locals.feature, feature);

            //     // panelRef.open();
            //     // setTimeout(() => {
            //     //     panelRef.iwgUpdatePosition();
            //     // }, 0);

            //     let popupContent = this.dynamicComponentService.injectComponent(
            //         DashboardpenelComponent,
            //         x => x.feature = feature
            //     );

            //     points = <Point>feature.geometry;
            //     c = points.coordinates;
            //     point = this.map.project(c);

            //     popup.setLngLat(c)
            //         .setDOMContent(popupContent)
            //         .addTo(this.map);
                    
            //     pointer.style.display = 'block';
            //     pointer.style.top = point.y + containerBounds.top + 'px';
            //     pointer.style.left = point.x + containerBounds.left + 'px';
            // });
            this.map.on('mousemove', (e) => { 
                let features = this.map.queryRenderedFeatures(e.point, {
                            layers: ['marker-labels', 'marker-circles']
                        });
                this.map.getCanvas().style.cursor = (features.length) ? 'pointer' : '';
                if (!features.length) {
                    pointer.style.display = 'none';
                    popup.remove();
                    // Reset filter
                    prevFeature = {properties: {}};
                    this.map.setFilter('areas-borders', ['!has', 'code']);
                    return;
                }
                let feature = features[0];
                this.map.setFilter('areas-borders', ['==', 'code', feature.properties.code]);

                // Add popover
                let points: Point = <Point>feature.geometry;
                let c = points.coordinates;
                let point = this.map.project(c);
                let containerBounds = this.map.getContainer().getBoundingClientRect();

                marker.innerHTML = feature.properties.workerCountMarkerLabel;
                
                pointer.style.display = 'block';
                pointer.style.top = point.y + containerBounds.top + 'px';
                pointer.style.left = point.x + containerBounds.left + 'px';
                //Object.assign(panelRef.config.locals.feature, feature);

                // panelRef.open();
                // setTimeout(() => {
                //     panelRef.iwgUpdatePosition();
                // }, 0);

                let popupContent = this.dynamicComponentService.injectComponent(
                    DashboardpenelComponent,
                    x => x.feature = feature
                );

                points = <Point>feature.geometry;
                c = points.coordinates;
                point = this.map.project(c);

                popup.setLngLat(c)
                    .setDOMContent(popupContent)
                    .addTo(this.map);
                    
                
            });

            this.map.on('mouseleave', () => {
                // this.map.getCanvas().style.cursor = '';
                popup.remove();
            });

            this.map.on('click', (e) => {
                let features = this.map.queryRenderedFeatures(e.point, {
                    layers: ['marker-labels', 'marker-circles']
                });                
                if (!features.length) {
                    return;
                }

                let country = features[0].properties.CountryAbbreviation;
                let state;
                let global_scope;
                if (country === 'US') {
                    global_scope = 3;                    
                    state = features[0].properties.stateAbbreviation;
                }

                /*
                let service_id = 1;
                if (features[0].properties.RegularHours == 'null' && global_scope == 3)//US without hour tracking means AOR
                {
                    service_id = 2;
                }
                */
                let service_id = features[0].properties.ServiceTypeID;

                let start_date = features[0].properties.start;
                let end_date = features[0].properties.end;

                if (this.sharedService.getIsEmbed()) {
                    var redirectParams = { country: country, global_scope: global_scope, state: state, start: start_date, end: end_date };

                    //Remove empty value properties from the object.
                    for (var param in redirectParams)
                        if (!redirectParams[param]) delete redirectParams[param];

                    this.sharedService.sendPostMessageToParentWindow({ source: 2, service: service_id, queryParams: Object.entries(redirectParams).map(e => e.join('=')).join('&') });
                } else {
                    this.router.navigate(["assignments"],
                        { queryParams: { country: country, service: service_id, global_scope: global_scope, state: state, start: start_date, end: end_date } })
                }
            });
            this.map.resize();
        });
    }
    getFeatureByProperties(collection, properties) {
        let feature = collection.features.find(i => i.properties.code == properties.code);

        if (!feature) {           
            //this._$log.warn(`Can't find feature properties: ${JSON.stringify(properties)}`);
        }
        return feature;
    }
    setData(data) {
        if (!data) return false;
        let applyFeaturePropertiesFromObject = (feature, properties) => {
            feature = Object.assign({}, feature);

            feature.properties = Object.assign({}, feature.properties, properties);
            feature.properties.country = feature.properties.Country;
            feature.properties.state = feature.properties?.State?.Name;
            feature.properties.stateAbbreviation = feature.properties?.State?.Abbreviation;
            //feature.properties.image = feature.properties.ImageURL || feature.properties.State.ImageURL;
            if (feature.properties.state !== undefined) {
                feature.properties.image = feature.properties.State.ImageURL;
            } else {
                feature.properties.image = feature.properties.ImageURL;
            }
            feature.properties.billing = this.currency.transform(feature.properties.Billing, "$",);
            if (feature.properties.OvertimeHours !== null) {
                feature.properties.overtimeHours = this.number.transform(feature.properties.OvertimeHours, "2.2-2");
            }
            if (feature.properties.RegularHours !== null) {
                feature.properties.regularHours = this.number.transform(feature.properties.RegularHours, "2.2-2");
            }
            if (feature.properties.TotalHours !== null) {
                feature.properties.totalHours = this.number.transform(feature.properties.TotalHours, "2.2-2");
            }
            if (feature.properties.DoubletimeHours !== null) {
                feature.properties.doubletimeHours = this.number.transform(feature.properties.DoubletimeHours, "2.2-2");
            }
            if (feature.properties.Expenses !== null) {
                feature.properties.expenses = this.currency.transform(feature.properties.Expenses, '$');
            }

            feature.properties.pass = feature.properties.Pass;
            feature.properties.nopass = feature.properties.NoPass;

            feature.properties.start = feature.properties.StartDate;
            feature.properties.end = feature.properties.EndDate;

            feature.properties.workerCount = feature.properties.WorkerCount;
            feature.properties.workerCountMarkerLabel = feature.properties.workerCount > 9999 ?
                '9999+' :
                feature.properties.workerCount;
            if (feature.properties.ServiceTypeID !== null) {
                feature.properties.serviceTypeID = this.number.transform(feature.properties.ServiceTypeID, "2.2-2");
                let country = feature.properties.CountryAbbreviation;
                let global_scope;
                if (country === 'US') {
                    global_scope = 3;
                }

                if (feature.properties.ServiceTypeID == 1) {
                    feature.properties.assignmentLabel = 'Assignments';
                }
                else if (feature.properties.ServiceTypeID == 2) {
                    feature.properties.assignmentLabel = 'Engagements';
                }
                else if (feature.properties.ServiceTypeID == 3) {
                    feature.properties.assignmentLabel = 'Evaluations';
                }

            }

            feature.properties.EntityCurrencyCode = this.user.getDefaultEntityCurrencyCode();

            return feature;
        }
        let markerFeatures = data
            .map(item => this.getFeatureByProperties(areaCentroids, {
                //code: _([item.CountryAbbreviation, _.property('State.Abbreviation')(item)]).compact().join('-'), [item.CountryAbbreviation, item.CountryAbbreviation.State?.Abbreviation ].join('-')
                code: this.setCountryAbbreviation(item)
            }))
            .map((feature, i) => applyFeaturePropertiesFromObject.bind(this)(feature, data[i]))
            .filter(feature => feature.type);       

        let interval = setInterval(() => {
            if (!this.maploaded) {
                return;
            }
            (this.map.getSource('country-centroids') as mapboxgl.GeoJSONSource).setData({
                type: 'FeatureCollection',
                features: markerFeatures
            });
            let visibleCountryCodes = markerFeatures.map(f => f.properties.code);
            this.map.setFilter('areas', ['in', 'code', ...visibleCountryCodes]);            
            clearInterval(interval);
        }, 1000);
    }
    setFitIsoA2(isoA2) {
        let code = isoA2;

        if (!code) {
            this.dropBounds();
            return false;
        }       

        let countryBounds = this.getFeatureByProperties(areaBounds, {code});

        if (!countryBounds?.geometry?.coordinates) {
            this.dropBounds();
            return false;
        }
        let bounds = countryBounds?.geometry?.coordinates.reduce(function (bounds, coord) {
            return bounds.extend(coord);
            }, new mapboxgl.LngLatBounds());
        // let bounds = _(countryBounds?.geometry?.coordinates).reduce((b, c) => b.extend(c), new mapboxgl.LngLatBounds());

        this.map.setMaxBounds(bounds);
    }
    onMapLoaded(event): void {
        event.map.resize();
    }
    dropBounds() {
        if(this.map) {
            this.map.setMaxBounds([[-180, -84], [180, 84]]);
            this.map.fitBounds([[-180, -84], [180, 84]], {
                animate: false
            });
        }
    }

    setCountryAbbreviation(countryAbbr) {
        let abbreviation;
        if(countryAbbr.State == null) {
            abbreviation = countryAbbr.CountryAbbreviation;
        }
        else {
            abbreviation = [countryAbbr.CountryAbbreviation, countryAbbr.State.Abbreviation ].join('-');
        }
        return abbreviation;
    }
}
